@if (isLoading) {
  <div class="spinner-wrap">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'MESSAGES.LOADING' | translate }}</span>
    </div>
  </div>
}

<div class="sales-prices-search form-search mb-2">
  <div class="input-search d-flex align-items-center">
    <input
      type="text"
      [value]="searchTerm"
      placeholder="Search..."
      (input)="onSearchChange($any($event.target).value)"
    />
    <span class="search-icon" aria-hidden="true">
      <img src="assets/img/search.svg" alt="" />
    </span>
  </div>
</div>

@if (totalItems > 0) {
  @if (pagedSalesPrices$ | async; as salesPrices) {
    <div class="uom-table-wrapper">
      <table class="table table-sm uom-table">
        <thead>
          <tr>
            <th>{{ 'TABLE_HEADERS.NUMBER' | translate }}</th>
            <th>{{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.SALES_START' | translate }}</th>
            <th>{{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.SALES_END' | translate }}</th>
            <th>{{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.SALES_UOM' | translate }}</th>
            <th>{{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.SALES_CURRENCY' | translate }}</th>
            <th>{{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.SALES_MIN_QTY' | translate }}</th>
            <th>{{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.SALES_UNIT_PRICE' | translate }}</th>
            <th>{{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.SALES_LINE_DISC' | translate }}</th>
            <th>{{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.SALES_PRICE_UOM' | translate }}</th>
            <th>{{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.SALES_ORDER_MULTIPLE' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (price of salesPrices; track $index) {
            <tr>
              <td>{{ price.lineNumber ?? notFound }}</td>
              <td>{{ price.startingDate | date: 'yyyy-MM-dd' }}</td>
              <td>{{ (price.endingDate | date: 'yyyy-MM-dd') || notFound }}</td>
              <td>{{ price.unitOfMeasureCode || notFound }}</td>
              <td>{{ price.currencyCode || notFound }}</td>
              <td>{{ price.minimumQuantity | number: '1.2-2' }}</td>
              <td>{{ price.unitPrice | number: '1.2-2' }}</td>
              <td>{{ price.lineDiscountPercent | number: '1.2-2' }}</td>
              <td>{{ price.priceUom | number: '1.2-2' }}</td>
              <td>{{ price.orderQuantityMultiple | number: '1.2-2' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <app-paginator
    class="d-flex justify-content-center mt-3 mb-0"
    [totalItems]="totalItems"
    [pageSize]="pageSize"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onChangePageSize($event)"
  />
} @else if (!isLoading) {
  {{ notFound }}
}

